<template>
  <v-img
    :src="require('@/assets/login/bg_space5.png')"
    lazy-src="require('@/assets/login/bg_space5.png')"
    aspect-ratio="1"
    max-width="100vw"
    max-height="100vh"
    cover
  >
  <!-- <Boxlogin/> -->
  <div class="box-login slide-in-bottom">
    <div class="content-login elevation-2">
      <v-img src="../../assets/logo_inet.png" alt="logo inet" aspect-ratio="1.7" width="120" contain transition="scale-transition"></v-img>
      <v-form
        ref="form"
        v-model="valid"
        :lazy-validation="lazy"
        class="form-contain-center"
      >
        <v-text-field
          v-model="email"
          :rules="emailRules"
          label="E-mail"
          required
          class="title-login"
          style="width: 100%;"
        ></v-text-field>

        <v-text-field
          v-model="password"
          :rules="passwordRules"
          label="Password"
          required
          class="title-login"
          :append-icon="showPassword ? 'mdi-eye' : 'mdi-eye-off'"
          :type="showPassword ? 'text' : 'password'"
          @click:append="showPassword = !showPassword"
        ></v-text-field>

        <!-- <v-btn
          :disabled="!valid"
          color="success"
          class="mr-4"
          @click="validate"
        >
          Login
        </v-btn> -->
        <v-btn class="content-login-button-title content-login-button content-login-button2" :disabled="!valid" @click="validate">
          Login
        </v-btn>
      </v-form>
    </div>
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1440 320"><path fill="#fff" fill-opacity="1" d="M0,64L24,85.3C48,107,96,149,144,160C192,171,240,149,288,138.7C336,128,384,128,432,128C480,128,528,128,576,154.7C624,181,672,235,720,224C768,213,816,139,864,117.3C912,96,960,128,1008,144C1056,160,1104,160,1152,181.3C1200,203,1248,245,1296,224C1344,203,1392,117,1416,74.7L1440,32L1440,0L1416,0C1392,0,1344,0,1296,0C1248,0,1200,0,1152,0C1104,0,1056,0,1008,0C960,0,912,0,864,0C816,0,768,0,720,0C672,0,624,0,576,0C528,0,480,0,432,0C384,0,336,0,288,0C240,0,192,0,144,0C96,0,48,0,24,0L0,0Z"></path></svg>
  </div>
  <vue-parallax-view class="my-parallax" :layers="layers" width="100%" height="100%" />
  </v-img>
</template>

<script>
// import { Boxlogin } from '@/components/index'
import 'vue-parallax-view/dist/vue-parallax-view.css'

export default {
  name: 'Contentlogin',
  // components: {
  //   Boxlogin
  // },
  data () {
    return {
      layers: [
        {
          name: 'moon',
          horizontalDisplacement: 0.1,
          verticalDisplacement: 0.1,
          image: require('@/assets/login/bg_moon.png'),
          class: 'my-custom-layer-class1'
        },
        {
          name: 'star',
          horizontalDisplacement: 0.15,
          verticalDisplacement: 0.15,
          image: require('@/assets/login/bg_space_tr5.png'),
          class: 'my-custom-layer-class2'
        },
        {
          name: 'mountain',
          horizontalDisplacement: 0.05,
          verticalDisplacement: 0.05,
          image: require('@/assets/login/bg_space_tr3.png'),
          class: 'my-custom-layer-class3'
        },
        {
          name: 'ground',
          horizontalDisplacement: 0.07,
          verticalDisplacement: 0.07,
          image: require('@/assets/login/bg_space_tr8.png'),
          class: 'my-custom-layer-class4'
        }
      ],
      showPassword: false,
      valid: true,
      email: '',
      emailRules: [
        v => !!v || 'E-mail is required',
        v => /.+@.+\..+/.test(v) || 'E-mail must be valid'
      ],
      password: '',
      passwordRules: [
        v => !!v || 'Password is required',
        v => (v && v.length >= 6) || 'Password must be more than 6 characters'
      ],
      lazy: false
    }
  },
  methods: {
    validate () {
      this.$refs.form.validate()
      this.goHome()
    },
    reset () {
      this.$refs.form.reset()
    },
    resetValidation () {
      this.$refs.form.resetValidation()
    },
    goHome () {
      this.$router.push('orgchart')
    }
  }
}
</script>

<style>
@import '../../css/Login.css';
</style>
